//this is the district list;
const districtList = [
    {
        id: 'C',
        color: "#777",
        opacity: .5,
        link: 'commercial-districts-c1-c8',
    },
    {
        id: 'C1',
        color: "#BAE7F3",
        opacity: .5,
        link: 'c1-c2',
    },
    {
        id: 'C2',
        color: "#86D4EA",
        opacity: .5,
        link: 'c1-c2',
    },
    {
        id: 'C3',
        color: '#52C1E0',   
        opacity: .5,
        link: 'c3-c3a',
    },
    {
        id: 'C4',
        color: '#25ABD0',
        opacity: .5,
        link: 'c4',
    },
    {
        id: 'C5',
        color: '#1E8FAE',
        opacity: .5,
        link: 'c5',
    },
    {
        id: 'C6',
        color: '#18728B',
        opacity: .5,
        link: 'c6',
    },    
    {
        id: 'C7',
        color: '#125669',
        opacity: .8,
        link: 'c7',
    },
    {
        id: 'C8',
        color: '#0C3946',
        opacity: .8,
        link: 'c8',
    },
    {
        id: 'M',
        color: "#777",
        opacity: .5,
        link: 'mfg-districts'
    },
    {
        id: 'M1',
        color: "#EBAA98",
        opacity: .5,
        link: 'm1',
    },
    {
        id: 'M2',
        color: "#E18066",
        opacity: .5,
        link: 'm2',
    },
    {
        id: 'M3',
        color: "#CC4C28",
        opacity: .5,
        link: 'm3',
    },
    {
        id: 'R',
        color: "#777",
        opacity: .5,
        link: 'residence-districts-r1-r10'
    },
    {
        id: 'R1',
        color: "#FBEEDA",
        opacity: .5,
        link: 'r1',
    },
    {
        id: 'R2',
        color: "#F7DDB6",
        opacity: .5,
        link: 'r2',
    },
    {
        id: 'R3',
        color: "#F3CC91",
        opacity: .5,
        link: 'r3',
    },
    {
        id: 'R4',
        color: "#EFBA6C",
        opacity: .5,
        link: 'r4',
    },
    {
        id: 'R5',
        color: "#E79823",
        opacity: .5,
        link: 'r5',
    },
    {
        id: 'R6',
        color: "#CA8216",
        opacity: .5,
        link: 'r6',
    },
    {
        id: 'R7',
        color: "#A56A12",
        opacity: .5,
        link: 'r7',
    },
    {
        id: 'R8',
        color: "#81530E",
        opacity: .5,
        link: 'r8',
    },
    {
        id: 'R9',
        color: "#5C3B0A",
        opacity: .5,
        link: 'r9',
    },
    {
        id: 'R10',
        color: "#372306",
        opacity: .5,
        link: 'r10',
    },
];

export default districtList;